import { Link, useNavigate } from "react-router-dom"
import Pagination from "../../Components/Pagination"
import { MyContext } from "../../Components/Context";
import { useContext } from "react";
import SearchField from "../../Components/Forms/SearchField";


export default function DerniereTransaction({data}){


    const navigate = useNavigate();
    const {actifItem, setActifItem} = useContext(MyContext);
    

    const tableItems = [
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            position: "10 Mars 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
        {
            avatar: "https://i.pinimg.com/564x/53/4f/3b/534f3b6dfd11ac8441587bb88cea3aab.jpg",
            id: "ANC-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            price: "120K XAF/semaine"
        },
    ]

    return (
        <div className="">
            <p className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">Dernieres Transaction</p>
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm">
                <table className="w-full text-sm text-left table-auto">
                    <thead className="font-medium text-gray-600 bg-gray-200 border-b dark:text-gray-200 dark:bg-gray-800 dark:border-gray-600">
                        <tr>
                            <th className="px-6 py-3">Id</th>
                            <th className="px-6 py-3">type</th>
                            <th className="px-6 py-3">montant</th>
                            <th className="px-6 py-3">Date de creation</th>
                            <th className="px-6 py-3">Telephone</th>
                            <th className="px-6 py-3">Statut</th>
                            <th className="px-6 py-3">PaiementId</th>
                            <th className="px-6 py-3">DistributionId</th>
                            <th className="px-6 py-3">XReference</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left transition bg-gray-200 border-gray-600 rounded cursor-pointer hover:bg-gray-200 duration-900 dark:text-gray-200 dark:bg-gray-800 hover:text-gray-700"
                                        // onClick={()=>{
                                        //     navigate(`/annonce/details/${item.id}`)
                                        //     setActifItem('Annonces')
                                        // }}
                                    >
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <div>
                                                    <span className="block text-sm font-medium ">{item.id}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.type}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.amount}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.msisdn}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`px-2 py-1 rounded-full bg-opacity-15 font-bold ${item.status === 'CONFIRMED' ? 'bg-green-600 text-green-700' : item.status === 'INWAITED' ? 'bg-gray-600 text-gray-700' : 'bg-red-600 text-red-700'}}`}>{item.status}</span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.paiementId }</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.distributionId }</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.XReference}</td>
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}